import { gql } from '@apollo/client';

export const QUESTIONNAIRE_FIELDS = gql`
  fragment QuestionnaireFields on Questionnaire {
    _id
    title
    description
    difficultyLevel
    duration
    status
    proId
    pro {
      _id
      commercialName
    }
    questions {
      id
      type
      label
      helpText
      isRequired
      order
      options
      maxDurationSeconds
      maxFiles
      acceptedFileTypes
    }
    createdAt
    updatedAt
  }
`;

export const GET_QUESTIONNAIRES = gql`
  ${QUESTIONNAIRE_FIELDS}
  query GetQuestionnaires($query: String, $status: QuestionnaireStatus, $proId: ID, $pagination: QuestionnairePagination) {
    getQuestionnaires(query: $query, status: $status, proId: $proId, pagination: $pagination) {
      docs {
        ...QuestionnaireFields
        jobOffers {
          _id
          title
          jobNumber
        }
      }
      totalDocs
      limit
      page
      nextPage
      prevPage
      totalPages
      hasPrevPage
      hasNextPage
      pagingCounter
    }
  }
`;

export const GET_QUESTIONNAIRE = gql`
  ${QUESTIONNAIRE_FIELDS}
  query GetQuestionnaire($id: ID!) {
    getQuestionnaire(id: $id) {
      ...QuestionnaireFields
      jobOffers {
        _id
        title
        jobNumber
      }
    }
  }
`;

export const ADD_QUESTIONNAIRE = gql`
  ${QUESTIONNAIRE_FIELDS}
  mutation AddQuestionnaire($input: QuestionnaireInput!) {
    addQuestionnaire(input: $input) {
      ...QuestionnaireFields
    }
  }
`;

export const UPDATE_QUESTIONNAIRE = gql`
  ${QUESTIONNAIRE_FIELDS}
  mutation UpdateQuestionnaire($id: ID!, $input: QuestionnaireInput!) {
    updateQuestionnaire(id: $id, input: $input) {
      ...QuestionnaireFields
    }
  }
`;

export const DELETE_QUESTIONNAIRE = gql`
  mutation DeleteQuestionnaire($id: ID!) {
    deleteQuestionnaire(id: $id) {
      acknowledged
      matchedCount
      modifiedCount
      upsertedCount
      upsertedId
    }
  }
`;

export const ARCHIVE_QUESTIONNAIRE = gql`
  ${QUESTIONNAIRE_FIELDS}
  mutation ArchiveQuestionnaire($id: ID!) {
    archiveQuestionnaire(id: $id) {
      ...QuestionnaireFields
    }
  }
`;

export const DUPLICATE_QUESTIONNAIRE = gql`
  ${QUESTIONNAIRE_FIELDS}
  mutation DuplicateQuestionnaire($id: ID!) {
    duplicateQuestionnaire(id: $id) {
      ...QuestionnaireFields
    }
  }
`;
